export default ['food', 'net carbs'];
